import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@cmps/ng-bootstrap';
import { CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsAuthModule } from '../auth/auth.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsEventCentreNavButtonModule } from '../notification/event-centre';
import { CmpsLazyRouterModule } from '../route.module';
import {
    CmpsTeamsCallChatMenuNavButtonModule,
    CmpsTeamsCallTaskListNavButtonModule,
} from '../teams-call';
import { CmpsUserModule } from '../user/user.module';
import { CmpsWebFormModule } from '../webform/webform.module';

import {
    LinkContentNavDirective,
    LinkNavComponent,
} from './link.nav.component';
import { DropdownCardDirective, NavComponent } from './nav.component';
import { TranslationIdMap } from './nav.i18n';
import { NavService } from './nav.service';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgbDropdownModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsLazyRouterModule,
        CmpsUserModule,
        CmpsAuthModule,
        CmpsWebFormModule,
        CmpsEventCentreNavButtonModule,
        CmpsTeamsCallChatMenuNavButtonModule,
        CmpsTeamsCallTaskListNavButtonModule,
        CmpsIconModule,
    ],
    declarations: [
        LinkContentNavDirective,
        LinkNavComponent,
        DropdownCardDirective,
        NavComponent,
    ],
    exports: [NavComponent],
})
export class CmpsNavModule {
    static forRoot(): ModuleWithProviders<CmpsNavModule> {
        return {
            ngModule: CmpsNavModule,
            providers: [NavService],
        };
    }
}
